/** @jsx jsx */
import { jsx } from '@emotion/react';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import EnterpriseLearningPathsModule from 'bundles/page-config-common/components/enterprise/EnterpriseLearningPathsModule';
import EnterpriseSingleLearningPathModule from 'bundles/page-config-common/components/enterprise/EnterpriseSingleLearningPathModule';
import EnterpriseTailoredLearningModule from 'bundles/page-config-common/components/enterprise/EnterpriseTailoredLearningModule';
import HomeSection from 'bundles/page-config-common/components/shared/HomeSection';
import { useEnterpriseBadgeCollections } from 'bundles/page-config-common/contexts/enterprise/EnterpriseBadgeCollectionsContext';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/ThirdPartyOrganizationContext';

/**
 * @description This module renderer is used to render the Enterprise Learning Paths (Badge Collections) module on the home page.
 */
const EnterpriseLearningPathsModuleRenderer = () => {
  const { enterpriseBadgesWithCollection } = useEnterpriseBadgeCollections();
  const thirdPartyOrg = useThirdPartyOrganization();

  if (enterpriseBadgesWithCollection.length === 0) {
    return null;
  }

  const enableEnterpriseHomeRefresh = GrowthDiscoveryEpicClient.preview('enableEnterpriseHomeRefresh');

  const renderLearningPathsModule = () => {
    if (enableEnterpriseHomeRefresh) {
      return (
        <EnterpriseTailoredLearningModule
          enterpriseBadgesWithCollection={enterpriseBadgesWithCollection}
          orgName={thirdPartyOrg?.name}
        />
      );
    } else if (enterpriseBadgesWithCollection.length > 1) {
      return <EnterpriseLearningPathsModule enterpriseBadgesWithCollection={enterpriseBadgesWithCollection} />;
    } else {
      return <EnterpriseSingleLearningPathModule enterpriseBadgeWithCollection={enterpriseBadgesWithCollection[0]} />;
    }
  };

  return (
    <HomeSection className="PageConfig_EnterpriseLearningPaths" dataTestId="enterprise-learning-paths">
      {renderLearningPathsModule()}
    </HomeSection>
  );
};

export default EnterpriseLearningPathsModuleRenderer;
